import React from 'react'
import PropTypes from 'prop-types'
import { EventMagazineRow } from '@/component/Primitive/Events'
import generateMagazineImage from './lib/magazine-image-generator'

const EventMagazineRowWidget = ({ items, ...other }) => {
  const mappedItems = items.map((item) => {
    return {
      image: generateMagazineImage(item.magazine.images)
    }
  })
  return <EventMagazineRow items={mappedItems} {...other} />
}

EventMagazineRowWidget.propTypes = {
  items: PropTypes.array,
  theme: PropTypes.string
}

export default EventMagazineRowWidget
